import React from "react";
import { useTranslation } from "react-i18next";
import { PickSlipAlert } from "@/features/pickems/components/pick-slip/PickSlipAlert";
import { Clamp } from "@picklebet/ui";
import type { VariantProps } from "class-variance-authority";
import type { alertVariants } from "@picklebet/ui";

import * as styles from "./PickSlipMessage.module.scss";

type PickSlipMessageVariant = VariantProps<typeof alertVariants>["variant"];

type PickSlipMessageProps = {
  type?: PickSlipMessageVariant;
  message: string;
  actionText?: string;
  action?: () => void;
};

const PickSlipMessage = ({
  type,
  message,
  actionText,
  action,
}: PickSlipMessageProps) => {
  const { t } = useTranslation();

  return (
    <PickSlipAlert
      variant={type}
      clamp={
        actionText || action ? (
          <Clamp
            className={styles.clickable}
            onClick={action ?? (() => {})}
            variant={type}
          >
            {actionText ?? "Got It"}
          </Clamp>
        ) : null
      }
    >
      {t(message, message)}
    </PickSlipAlert>
  );
};

export { PickSlipMessage };
export type { PickSlipMessageVariant };
